import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { RefFileObjectService } from 'src/app/librarys/serves/public/ref-file-object.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $: any;

@Component({
  selector: 'app-sw-sign',
  templateUrl: './sw-sign.component.html',
  styleUrls: ['./sw-sign.component.css']
})
export class SwSignComponent implements OnInit {

   @ViewChild("userSign") userSign: SwModalframeComponent

     @Output() callback = new EventEmitter(); //抛出事件
     
   fileCode = "APM_PERSON_SING_IMAGE";//用户签名图片策略
   signFiles: any = { addList: [] };
  //用户信息
  UserModel: any = {};

  constructor(
    private box: SwMassageBoxService, //提示框服务
     private User: GetUserModelService, //获取用户服务
     private fileService: RefFileObjectService,   //附件服务
  ) { 
        //获取用户信息
        this.UserModel = this.User.getUser();
  }

  ngOnInit() {
  }

  getsignFileInfo(event) {
    //上传附件成功 根据this.workFlowFiles3.addList.length判断是否上传了附件
    this.signFiles = event;
  }
  
  ok(){
    if (this.signFiles && this.signFiles.addList && this.signFiles.addList.length > 0) {
        this.fileService.save(this.UserModel.userId, this.fileCode, this.signFiles.addList).subscribe(
          res => {
            if(res && res.code == 200){
              this.box.success("上传签名成功！");
              this.canel();
            }else{
              this.box.danger("上传签名失败！");
              this.canel();
            }
          }
        );
    }else{
      this.box.danger("请上传签名！");
    }
  }
  canel(){
    this.callback.emit(true);
    // this.userSign.toggle();
    $(".modal-backdrop.fade.in").remove();
  }
}
